<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="tenant">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}时间设置
        </div>
        <div class="fr">
          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <!-- <b>主信息</b> -->
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <!-- <em class="f-red">*</em> -->
                  网点名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="tenant.siteName" clearable readonly="true">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog=true"></i>
                  </el-input>
                </td>
                <th>
                  <em class="f-red">*</em>
                  时间名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="tenant.engineerName" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  启用
                </th>
                <td>
                  <el-select v-model="tenant.usable" style="width: 165px;">
                    <el-option label="禁用" :value="0"/>
                    <el-option label="启用" :value="1"/>
                  </el-select>
                </td>
               
                
                
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  时间类型
                </th>
                <td>
                  <el-select v-model="tenant.timeType" style="width: 165px;">
                    <el-option label="按完工时间" :value="1"/>
                    <el-option label="按网点确认完工时间" :value="2"/>
                    <el-option label="按进入结算池时间" :value="3"/>

                  </el-select>
                </td>
                <th>
                    <em class="f-red">*</em>结算时间
                  </th>
                  <td style="position: absolute; width: 20vw!important;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;">
                    <el-date-picker class="current-date-picker"
                                    v-model="tenant.date"
                                    type="daterange"
                                    align="right"
                                    unlink-panels
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format='yyyy-MM-dd'>
                    </el-date-picker>
                  </td>
                <!-- <th>
                  <em class="f-red">*</em>
                  结算开始时间
                </th>

                <td>
                  <el-date-picker
                  v-model="tenant.beginDate"
                  type="datetime"
                  placeholder="选择日期时间">
                </el-date-picker>
                </td>
                <th>
                  <em class="f-red">*</em>
                  结算结束时间
                </th>
                <td>
                  <el-date-picker
                    v-model="tenant.endDate"
                    type="datetime"
                    placeholder="选择日期时间">
                  </el-date-picker>
                </td> -->
              
              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ tenant.createBy }}</td>
                <th>创建时间</th>
                <td>{{ tenant.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>
         
        </div>

      </div>
    </el-form>
    <preconditionDialog v-if="showPreconditionDialog" @commit="commitSelectedRow"
                        :visiable.sync="showPreconditionDialog" multi="true"
    />
  </div>
</template>
<script>
import preconditionDialog from '@/views/dialogCommon/radioSiteDialog.vue';
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
import store from "@/store";
import api from "@/api/projectApi";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";

export default {
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    Tinymce,
    preconditionDialog,
  },
  data() {
    return {
      value1:"",
      picList: [],
      fileList: [],

      showPreconditionDialog: false,
      img_b: "",
      upload_btn: false, // 是否隐藏上传图片按钮
      radio: '1',
      showEdit: false,

      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      // 基本信息
      tenant: {
        date:'',
        timeType:1,
        beginDate:'',
        endDate:'',
        usable:1,
        tenantAttachmentDTOs: []
      },
      showProductCategoryDialog: false,

      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      areaOption: [],
      areaValues: [],
    };
  },
  computed: {
    api() {
      return api
    },
    // enabled: {}
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    // console.log(this.tenant,"tenant的值");
  },
  watch: {
    picList: {
      handler(newVal, oldVal) {
        this.tenant.engineerPic = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    fileList: {
      handler(newVal) {
        this.tenant.inoculateFile = uploadFileFormat(newVal)
      },
      deep: true
    }
  },
  mounted() {

    this.getData();
  },
  methods: {
    commitSelectedRow(data) {
      this.tenant.siteId = data.id
      this.tenant.siteName = data.name
    },

    handleRemove() {
      this.picList = []
    },
    handleSuccess(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList = echoFileFormat(res.data.url)
    },

    handleFileRemove() {
      this.fileList = []
    },
    handleFileSuccess(res, file, fileList) {
      console.log(res.data.url, "url")
      this.fileList = echoFileFormat(res.data.url)
    },


    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        request({
          url: api.sfSettleTime.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.tenant = response.data.data
          let tmpArr = []
          tmpArr.push(new Date(this.tenant.beginDate))
          tmpArr.push(new Date(this.tenant.endDate))
          console.log('转成啥', tmpArr)
          this.tenant.date = tmpArr
          this.picList = echoFileFormat(this.tenant.engineerPic)
          this.fileList = echoFileFormat(this.tenant.inoculateFile)
          this.echoAddress()
        })
      }
    },

    saveData() {
      console.log(this.tenant.date,"formData.date的值");
      this.tenant.beginDate=this.tenant.date[0]
      this.tenant.endDate=this.tenant.date[1]
      console.log(this.tenant.beginDate,this.tenant.endDate,'55555');
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            // var url = (this.isEdit ? api.sfSettleTime.updateDataUrl : api.sfSettleTime.addDataUrl);
            this.$http({
              url: api.sfSettleTime.saveDataUrl,
              method: `post`,
              data: this.tenant,
              isLoading: true,
            }).then(res => {
              this.$message.success('保存成功')
              this.$emit('editViewDataUpdate')
              this.$baseReload()
            })
          });
        }
      });
    },






    // handleChange() {
    //   const areaNode = this.$refs["cascader"].getCheckedNodes();
    //   console.log('handleNode', areaNode)
    //   if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
    //     if (areaNode[0].level == 1) {
    //       this.tenant.country = areaNode[0].label;
    //       this.tenant.province = null;
    //       this.tenant.city = null;
    //       this.tenant.county = null;
    //       this.tenant.town = null;
    //     } else if (areaNode[0].level == 2) {
    //       this.tenant.province = areaNode[0].label;
    //       this.tenant.city = null;
    //       this.tenant.county = null;
    //       this.tenant.town = null;
    //     } else if (areaNode[0].level == 3) {
    //       this.tenant.city = areaNode[0].label;
    //       this.tenant.county = null;
    //       this.tenant.town = null;
    //     } else if (areaNode[0].level == 4) {
    //       this.tenant.county = areaNode[0].label;
    //       this.tenant.town = null;
    //     } else if (areaNode[0].level == 5) {
    //       this.tenant.town = areaNode[0].label;
    //     }
    //     this.tenant.areaId = areaNode[0].value
    //   } else {
    //     this.tenant.areaId = null;
    //     this.tenant.country = null;
    //     this.tenant.province = null;
    //     this.tenant.city = null;
    //     this.tenant.county = null;
    //     this.tenant.town = null;
    //   }

    //   const panelRefs = this.$refs.cascader.$refs.panel
    //   if (panelRefs.activePath.length !== 0) {
    //     panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
    //   }

    // },

    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },
    // 地址数据回显
    echoAddress() {
      if (this.tenant.areaId !== null && this.tenant.areaId !== '') {
        // this.cascaderShow = false
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: {id: this.tenant.areaId}
        }).then(res => {
          console.log(res)
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          this.area = res.data.data.names
        })
      }
    },


  },
};
</script>
<style lang="scss" scoped>
// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  position: absolute !important;
  bottom: -57px;
}
</style>
